export const light = {
    name: "light-theme",
    colors: {
      background: "#FFFFFF",
      appBackground: "#F7F7F7",
      footer: "hsl(0, 1%, 38%)",
      text: "#2C2F36",
      themeIcon: 0,
      loopIcon: 0,
      menuHover: "#E0DED7",
      progressBarFill: "#005A9C",
      progressBarBackground: "#EF3E42",
      lineGraphBorder: "#D3D0C9",
      lineGraphFill: "#F4F3F1",
      border: "hsl(0, 0%, 87%)",
      buttonFill: "#F7F7F7",
      searchBar: "#D3D0C9",
      barFill: "#2C2F36",
      shimer1: "#E0DED7",
      shimer2: "#F7F7F7",
      portfolioText: "#2C2F36",
      portfolioButton: "#1AD761",
      portfolioDeleteButton: "#EF3E42",
      portfolioBackground: "#FFFFFF",
      datePicker: "0%",
      sideArrow: "#D3D0C9",
      mobileFooter: "#D3D0C9",
      modalFillerIcon: "#aaaaaa",
      modalIconBackground: "#D3D0C9"
    },
  };
  
  export const dark = {
    name: "dark-theme",
    colors: {
      background: "#191B1F",
      appBackground: "#1F2128",
      footer: "hsl(0, 0%, 93%)",
      text: "#FFFFFF",
      themeIcon: 100,
      loopIcon: 100,
      menuHover: "#1F2128",
      progressBarFill: "#FE8C01",
      progressBarBackground: "#FEE158",
      lineGraphBorder: "#2C2F36",
      lineGraphFill: "#1C1E24",
      border: "hsl(0, 0%, 78%)",
      buttonFill: "#2C2F36",
      searchBar: "#2C2F36",
      barFill: "#F7F7F7",
      shimer1: "#1F2128",
      shimer2: "#2C2F36",
      portfolioText: "#1AD761",
      portfolioButton: "#1AD761",
      portfolioDeleteButton: "#EF3E42",
      portfolioBackground: "#FFFFFF",
      datePicker: "100%",
      sideArrow: "#FFFFFF",
      mobileFooter: "#2C2F36",
      modalFillerIcon: "#0B0D0F",
      modalIconBackground: "#191B1F",
    }
  };